<template>
    <div class="card shadow-sm overflow-hidden">
        <div class="card-header d-flex align-items-center py-1 px-2">
            <div class="flex-grow-1">
                <strong>已選服務</strong>
            </div>
            <button class="btn btn-sm btn-light border btn-change"
                    v-on:click="isModalChangeServiceOpen = true">
                更改
            </button>
        </div>
        <div class="card-body p-2">
            <h6 class="font-weight-bold mb-0">
                {{ serviceName }}
            </h6>
            <p class="mb-0">
                <small>
                    {{ skuSelected ? skuSelected.name : "" }} {{ skuSelected ? `(${ skuSelected.code })` : "" }}
                </small>
            </p>
        </div>
        <div>
            <img class="service-thumbnail"
                 v-bind:alt="serviceName"
                 v-bind:src="`${ $config.apiUrl }/${ $config.apiVersion }/service/image/${ servicePhoto }`">
        </div>

        <modal-change-service v-bind:task-id="taskId"
                              v-bind:service-selected="service"
                              v-bind:sku-selected="sku"
                              v-model="isModalChangeServiceOpen">
        </modal-change-service>
    </div>
</template>

<script>
import ModalChangeService from "../ModalChangeService";
export default {
    name: "TaskService",
    components: {
        ModalChangeService,
    },
    props: {
        "taskId": {
            type: String,
            required: true,
        },
        "service": {
            type: Object,
            required: true,
        },

        "sku": {
            type: String,
        },
    },
    data () {
        return {
            isModalChangeServiceOpen: false,
        };
    },
    computed: {
        serviceName () {
            return this.service ?
                this.service.name :
                ""
        },

        servicePhoto () {
            if (this.service) {
                return this.service.photo[0];
            }
            return "";
        },

        skuSelected () {
            if (
                this.service &&
                this.sku
            ) {
                const target = this.service.sku
                    .find(
                        ({ _id }) => _id === this.sku
                    );
                if (target) {
                    return target;
                }
                return null;
            }
            return null;
        },
    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.card-header {
    font-size: 0.9rem;
}

.btn-change {
    line-height: 1.25;
    font-size: 0.8rem;
}

.service-thumbnail {
    height: 175px;
    width: 100%;
    object-fit: contain;
}
</style>
